"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Personality = void 0;
var Personality;
(function (Personality) {
    Personality["OUTGOING"] = "OUTGOING";
    Personality["INTROVERT"] = "INTROVERT";
    Personality["FRIENDLY"] = "FRIENDLY";
    Personality["FUNNY"] = "FUNNY";
})(Personality = exports.Personality || (exports.Personality = {}));
//# sourceMappingURL=Personality.js.map